const classes: Array<string> = [
    'filterrating',
    'filterdistance',
    'monthselector',
];

export default function initRatingGroups(): void {
    classes.forEach( ( clss ) => {
        document.querySelectorAll<HTMLElement>( `.${clss}` ).forEach( ( rating: HTMLElement ) => {
            rating.querySelectorAll( 'li' ).forEach( ( section: HTMLElement ) => {
                const input: HTMLInputElement | null = section.querySelector( 'input' );

                if ( !input ) {
                    return;
                }

                input.addEventListener( 'change', ( event: Event ): void => {
                    if ( section.classList.contains( `${clss}__group--active` ) ) {
                        section.classList.remove( `${clss}__group--active` );
                    } else {
                        section.classList.add( `${clss}__group--active` );
                    }
                } );

                section.addEventListener( 'mouseenter', ( event: Event ): void => {
                    section.classList.add( `${clss}__group--hover` );
                } );

                section.addEventListener( 'mouseleave', ( event: Event ): void => {
                    section.classList.remove( `${clss}__group--hover` );
                } );
            } );
        } );
    } );
}
